import { render, staticRenderFns } from "./SharedStrategyDetailPage.vue?vue&type=template&id=b0a936d0"
import script from "./SharedStrategyDetailPage.vue?vue&type=script&lang=js"
export * from "./SharedStrategyDetailPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports